/**
 * Created by jonas on 2019-08-21.
 */

import {Timeline, TimelineLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {ImmortalFruitsGameModuleConfig} from "../../ImmortalFruitsGameModuleConfig";
import {IImmortalFruitsWinRatioConfig} from "../../ImmortalFruitsGameConfig";
import {ImmortalFruitsGameMode} from "../../ImmortalFruitsGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";


export class WinEnd implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private _hasWin: boolean;
    private _tl: TimelineLite;
    private nextMode:string;
    private currentMode:string;

    /**
     * @constructs
     * @param stagger
     * @param abortStagger
     */
    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: ParsedGameData): void {
        this._hasWin = data.singleWin > 0;
        this.nextMode = data.nextMode;
        this.currentMode = data.mode;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedGameData): Timeline | null {
        if (!this._hasWin) {
            return null;
        }
        this._tl = new TimelineLite();

        if (data.isBigWin) {
            this._tl.add([
                ImmortalFruitsGameModuleConfig.winTextView.end(<IImmortalFruitsWinRatioConfig>data.currentWinRatioConfig!, 1, 0.2),
            ], 0);
        }
        if(data.isBigWin || !(this.currentMode===ImmortalFruitsGameMode.BONUS_WHEEL && (this.nextMode ===ImmortalFruitsGameMode.NORMAL||this.nextMode ===ImmortalFruitsGameMode.GAMBLE))){
              this._tl.add(ImmortalFruitsGameModuleConfig.countUpView.end(data.singleWin, 1, 0.2, data.isBigWin, this.currentMode===ImmortalFruitsGameMode.BONUS_WHEEL), 0);
        }
        return this._tl;
    }
    private onGameDataParsed(data:ParsedGameData){
        this.nextMode = data.nextMode;
        this.currentMode = data.mode;
    }
    /**
     * @inheritDoc
     * @param isActive
     * @param data
     */
    public abort(isActive: boolean, data: ParsedGameData): Timeline | null {
        if (isActive && this._tl && this._tl.timeline) {
            GameRoundManager.detachAndPlayTimeline(this._tl);
        } else {
            if (this._hasWin) {
                this.getAnimation(data);
            }
        }

        return null;
    }
}